import request from '@/utils/request';
import qs from 'qs';

export function exhibitTopCarouselPictures(data) {
  // let params = qs.stringify(data);
  let params = qs.parse(data);
  return request({
    url: '/exhibitPicture/exhibitTopCarouselPictures',
    method: 'get',
    headers: {
      // 'Content-Type': 'application/json',
      Accept: '*/*',
      // 'Access-Control-Allow-Origin':'*',
      // 'Origin':'http://10.5.98.242:7788',
    },
    params: params,
  });
}

export function exhibitTopCategory(data) {
  // let params = qs.stringify(data);
  let params = qs.parse(data);
  return request({
    url: '/exhibit/exhibitTopCategory',
    method: 'get',
    headers: {
      // 'Content-Type': 'application/json',
      Accept: '*/*',
      // 'Access-Control-Allow-Origin':'*',
      // 'Origin':'http://10.5.98.242:7788',
    },
    params: params,
  });
}

export function updateAllTopCategories(arr) {
  return request({
    url: '/exhibit/updateAllTopCategories',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
    },
    data: { categoryIds: arr },
  });
}
